import { QueryClient } from "@tanstack/react-query";
import Bugsnag from "~/lib/Bugsnag";
import { Build, Job } from "~/components/build/Show/lib/types";
import { AnnotationScope } from "~/components/build/Show/lib/types/Annotation";
import { allBuildAnnotationsQueryKey } from "~/components/build/Show/lib/queries/allBuildAnnotations";
import { allJobAnnotationsQueryKey } from "~/components/build/Show/lib/queries/allJobAnnotations";
import { jobAnnotationsQueryKey } from "~/components/build/Show/lib/queries/jobAnnotations";
import { jobQueryKey } from "~/components/build/Show/lib/queries/job";
import { stepJobsQueryKey } from "~/components/build/Show/lib/queries/stepJobs";

export function annotationsChangedHandler(
  queryClient: QueryClient,
  buildId: Build["id"],
  scope: AnnotationScope,
  jobUuid?: string,
): void {
  switch (scope) {
    case "build":
      queryClient.invalidateQueries({
        queryKey: allBuildAnnotationsQueryKey(buildId),
        exact: true,
      });
      break;
    case "job":
      queryClient.invalidateQueries({
        queryKey: allJobAnnotationsQueryKey(buildId),
        exact: true,
      });
      if (jobUuid) {
        queryClient.invalidateQueries({
          queryKey: jobAnnotationsQueryKey(buildId, jobUuid),
          exact: true,
        });
        // We invalidate the job here to correctly render the annotationCountsByStyle
        queryClient.invalidateQueries({
          queryKey: jobQueryKey(buildId, jobUuid),
          exact: true,
        });

        // Also invalidate step-jobs so the step drawer (opened via stepUuid
        // without jobUuid) refreshes annotation counts from its own data source.
        const cachedJob = queryClient.getQueryData<Job>(jobQueryKey(buildId, jobUuid));
        if (cachedJob?.stepUuid) {
          queryClient.invalidateQueries({
            queryKey: stepJobsQueryKey(buildId, cachedJob.stepUuid),
            exact: true,
          });
        }
      }
      break;
    default:
      Bugsnag.notify(`[annotationsChangedHandler] Unknown annotation scope: ${scope}`);
      break;
  }
}
